/* template */
<template><page><base-container><div :class='["btn-item"]'><cube-basic-picker/></div><div :class='["btn-item"]'><cube-slot-picker/></div><div :class='["btn-item"]'><cube-set-time-picker/></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_04e00ac8"}'>
.btn-item
  margin-bottom 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_04e00ac8"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_04e00ac8"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_04e00ac8"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-basic-picker':getComponent(require("./basic-picker.mpx?isComponent&outputPath=components%2Fbasic-picker78fba61e%2Findex")),'cube-slot-picker':getComponent(require("./slot-picker.mpx?isComponent&outputPath=components%2Fslot-pickerbc673572%2Findex")),'cube-set-time-picker':getComponent(require("./set-time-picker.mpx?isComponent&outputPath=components%2Fset-time-picker4d82d7a6%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>